export const setSelectedBonus = (payload) => {
  return {
    type: 'SET_SELECTED_BONUS',
    payload,
  };
};

export const resetSelectedBonus = () => {
  return {
    type: 'RESET_SELECTED_BONUS',
  };
};
